/* eslint-disable no-unused-vars */
import React from 'react';
import classnames from 'classnames';
import { DASHBOARD_TYPE, PAGE_TYPE } from '@utils/constants';
import UpdateDashboardPopup from '../UpdateDashboardPopup';
import styled from 'styled-components';

const StyledLink = styled.button`
  border: none;
  background-color: transparent;
  padding: 0;
  text-align: left;
  cursor: pointer;

  &:disabled {
    color: rgb(104 104 104 / 40%);
    font-style: italic;
    font-weight: 400;
  }

  width: 100% !important;
`;

const getDashboardNameByTemp = (tempDashboards, id) => {
  const tempDashboard = tempDashboards[id];
  if (!tempDashboard) {
    return '';
  }
  const { title } = tempDashboard;
  return title;
};

const getDashboardNameBySaved = (dashboards, id) => {
  const dashboard = dashboards.find(
    (savedDashboard) => parseFloat(savedDashboard.id) === parseFloat(id),
  );
  if (!dashboard) {
    return '';
  }
  const { name } = dashboard;
  return name;
};

const getDashboardNameByPageType = (pageType, id, tempDashboards, dashboards) => {
  if (pageType === PAGE_TYPE.TEMP_DASHBOARD) {
    return getDashboardNameByTemp(tempDashboards, id);
  }
  if (pageType === PAGE_TYPE.SAVED_DASHBOARD) {
    return getDashboardNameBySaved(dashboards, id);
  }
  return '';
};

const SaveDashboard = React.memo(
  ({
    className = '',
    pageType,
    id,
    dashboard,
    dashboardType,
    dashboards,
    tempDashboards,
    toggleVisible,
  }) => {
    const dashboardName = getDashboardNameByPageType(pageType, id, tempDashboards, dashboards);

    const handleClick = React.useCallback(
      () => {
        toggleVisible(true, id);
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [id],
    );

    return (
      <>
        {
          // VM doesnt require the button to render and we need to use the adapter as a whole
          dashboardType !== DASHBOARD_TYPE.VIEWER_MODULE && (
            <StyledLink className={classnames(className)} onClick={handleClick}>
              <span>Save</span>
            </StyledLink>
          )
        }
        <UpdateDashboardPopup
          id={pageType === PAGE_TYPE.SAVED_DASHBOARD ? id : -1}
          title={dashboardName}
          tempId={id}
          dashboard={dashboard}
          dashboardType={dashboardType}
        />
      </>
    );
  },
);

SaveDashboard.displayName = 'SaveDashboard';

export default SaveDashboard;
